import SectionWrapper from 'src/pages/SalesCannelVersion/Components/SectionWrapper';
import React from 'react';
import { Form, OriNumberInput, OriCheckbox } from 'src/components/Antd';
import css from './css.module.less';
import ItemWrapper from '@/src/components/Layouts/Item/Item';
import Row from '@/src/components/Layouts/Row/Row';
import Section from 'src/pages/SalesCannelVersion/Components/SectionContainer';
import { isNumber } from 'src/tools/helper';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import { last2Precision } from 'src/tools/regExp';

const Item = Form.Item;
const _base = 'voucherMethod';
const inputName = [_base, 'deduction'];
const excludeName = ['applyTo', 'flashSaleExcluded'];
import Tip from 'src/pages/SalesCannelVersion/SalesChannelDiscounts/Components/DiscountLastExpression';

const FixedReduction = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { currency, disabled } = props;
  return (
    <SectionWrapper
      title={`${getI18n('voucher.storeVoucherDetail.voucherValue')}`}>
      <Section bottomBorder className={css.innerSection}>
        <Row
          elements={[
            {
              child: (
                <ItemWrapper
                  title={`${getI18n(
                    'voucher.storeVoucherDetail.voucherValue',
                  )}*`}>
                  <Item
                    name={inputName}
                    rules={[
                      {
                        validator: async (x, value) => {
                          if (!isNumber(value)) {
                            return Promise.reject(
                              new Error(getI18n('general.pleasefillthisfield')),
                            );
                          }
                          if (value < 1) {
                            return Promise.reject(
                              new Error(
                                getI18n(
                                  'voucher.storeVoucherDetail.valueshouldbenolessthan1',
                                ),
                              ),
                            );
                          }
                          if (!last2Precision.test(value)) {
                            return Promise.reject(
                              new Error(getI18n('general.twoDecimal')),
                            );
                          }
                        },
                      },
                    ]}>
                    <OriNumberInput
                      size='large'
                      suffix={currency}
                      disabled={disabled}
                    />
                  </Item>
                </ItemWrapper>
              ),
            },
            { child: <React.Fragment /> },
          ]}
        />
      </Section>
      <Section bottomBorder className={css.excludeSection}>
        <Item name={excludeName} valuePropName={'checked'}>
          <OriCheckbox disabled={disabled}>
            {getI18n('voucher.storeVoucherDetail.excludeflashsaleitems')}
          </OriCheckbox>
        </Item>
      </Section>
      <Tip
        title={getI18n('voucher.storeVoucherDetail.voucherCalculationRule')}
        content={getI18n(
          'voucher.storeVoucherDetail.voucherCalculationRuleContent',
        )}
        overlayDescription={getI18n(
          'voucher.storeVoucherDetail.discountCalculationruledesc',
        )}
      />
    </SectionWrapper>
  );
};
export default FixedReduction;
